var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.feauturedesByPosition.length > 0)?_c('div',{staticClass:"df-section-featured-container"},_vm._l((_vm.feauturedesByPosition),function(feautured){return _c('df-card-feautured',{key:feautured.uniqueId,attrs:{"promotion":_vm.promotion,"feautured":feautured}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }